module.exports = __webpack_public_path__ + "static/img/trbanner.8da1b17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/trbanner.jpg
// module id = PRgm
// module chunks = 9